"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { Lock, Mail, Loader2 } from "lucide-react";
import Link from "next/link";

if (!process.env.NEXT_PUBLIC_API_URL) {
  throw new Error("NEXT_PUBLIC_API_URL is not defined");
}

const API = process.env.NEXT_PUBLIC_API_URL;

export default function LoginPage() {
  const router = useRouter();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setError("");
    setLoading(true);

    try {
      const form = new URLSearchParams();
      form.append("email", email);
      form.append("password", password);

      const res = await fetch(`${API}/api/auth/login`, {
        method: "POST",
        credentials: "include", // فقط کوکی
        body: form,
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Login failed");
      }

      // ✅ اگر رسیدیم اینجا یعنی لاگین قطعاً موفق بوده
      router.push("/dashboard");
    } catch (e: any) {
      setError(e.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="relative h-screen w-screen overflow-hidden
                 bg-gradient-to-br from-black via-indigo-950 to-purple-950
                 text-white"
    >
      {/* Background glows */}
      <div className="absolute -top-40 -left-40 w-[500px] h-[500px]
                      bg-indigo-600/30 rounded-full blur-3xl" />
      <div className="absolute top-1/3 -right-40 w-[500px] h-[500px]
                      bg-fuchsia-600/30 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-1/4 w-[600px] h-[600px]
                      bg-purple-700/20 rounded-full blur-3xl" />

      <div className="relative z-10 h-full w-full flex items-center justify-center px-4">
        <div className="w-full max-w-md rounded-2xl
                        bg-white/10 backdrop-blur-2xl
                        border border-white/20
                        shadow-[0_20px_60px_rgba(0,0,0,0.5)]
                        p-8 space-y-6">

          <div className="text-center space-y-2">
            <h1 className="text-3xl font-extrabold">CompuBio</h1>
            <p className="text-sm text-indigo-200">
              AI-powered bioinformatics workspace
            </p>
          </div>

          <div className="text-center">
            <Link href="/" className="text-sm text-indigo-300 hover:text-white">
              ← Back to Home
            </Link>
          </div>

          <div className="relative">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-indigo-300" size={18} />
            <input
              type="email"
              placeholder="Email address"
              className="w-full pl-10 pr-3 py-2 rounded-xl
                         bg-white/10 border border-white/20
                         focus:ring-2 focus:ring-indigo-500"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="relative">
            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-indigo-300" size={18} />
            <input
              type="password"
              placeholder="Password"
              className="w-full pl-10 pr-3 py-2 rounded-xl
                         bg-white/10 border border-white/20
                         focus:ring-2 focus:ring-indigo-500"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {error && (
            <div className="text-sm text-red-300 text-center">{error}</div>
          )}

          <button
            onClick={handleLogin}
            disabled={loading}
            className="w-full py-3 rounded-xl font-semibold
                       bg-gradient-to-r from-indigo-600 to-purple-600
                       flex items-center justify-center gap-2
                       disabled:opacity-50"
          >
            {loading && <Loader2 className="animate-spin" size={18} />}
            {loading ? "Signing in..." : "Login"}
          </button>

          <p className="text-center text-sm text-indigo-200">
            No account?{" "}
            <Link href="/register" className="font-semibold text-white">
              Create one
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
